<style scoped>
  .landing {
    background-image: url('~/static/base/default.jpeg');
    min-height: 72vh;
    margin-bottom: -45px !important;
    margin-left: -15px;
    margin-right: -15px;
  }
</style>

<template>
  <div>
    <section class="landing background-cover"></section>
  </div>
</template>

<script>

export default {
  methods: {
    backToHome() {
      this.$router.push({ name: 'Index' });
    },
    sendToLogin() {
      this.$router.push({ name: 'Login' });
    },
    unlockSuccess() {
      this.$swal({
        title: 'Success',
        text: 'The account was successfully unlocked.',
        type: 'success',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(this.sendToLogin);
    },
    unlockFailure(error) {
      this.$swal({
        title: 'Unlock failed',
        text: error.response.data.message,
        type: 'error',
        confirmButtonText: 'Ok',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(this.backToHome);
    },
  },
  created() {
    const userId = this.$route.query.user_id;
    const token = this.$route.query.token;

    this.$reqs.get(`/unlock_account?user_id=${userId}&token=${token}`, null, false)
      .then(this.unlockSuccess)
      .catch(this.unlockFailure);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/AccountUnlock.vue